export const ADMIN_CONFIG = {
    pagination: {
        defaultLimit: 10,
        limits: [10, 20, 50, 100],
        maxVisiblePages: 5,
    },
    timePeriods: [
        { value: "1d", label: "Last 24 hours" },
        { value: "7d", label: "Last 7 days" },
        { value: "30d", label: "Last 30 days" },
        { value: "90d", label: "Last 90 days" },
        { value: "180d", label: "Last 6 months" },
        { value: "365d", label: "Last year" },
    ],
    defaultPeriod: "7d",
    template: {
        defaultDPI: 300,
        dpiOptions: [150, 200, 300, 400, 600],
        defaultUnit: "mm",
        units: ["mm", "cm", "inches", "px"],
    },
    product: {
        defaultGSM: 350,
        defaultQuantity: 100,
        defaultBasePrice: 300,
        defaultDiscountPrice: 250,
    },
};

export const getAdminConfig = async () => {
    try {
        const response = await fetch("/api/admin/config");
        if (response.ok) {
            const config = await response.json();
            return { ...ADMIN_CONFIG, ...config.data };
        }
    } catch (error) {
        console.warn("Failed to fetch admin config, using defaults:", error);
    }
    return ADMIN_CONFIG;
};

